import commonGetters from '@/store/data/common/getters'
import { isNil } from 'lodash'

const getters = {
    /**
     * Get Only active Audience (not shared)
     *
     * @param {Object} state - vuex audience module state
     * @returns {Array} List of audiences
     */
    audiencesActiveError: state => state.audiencesActiveError,

    getActiveAudiences: state => () => {
        return state.list.filter(item => item.status === 'active' && isNil(item.sharedAudience))
    },

    getAudiencesGeoradar: state => {
        return state.list.filter(item => item.type === 'georadar' && isNil(item.sharedAudience))
    },

    getAudiencesCclone: state => {
        return state.list.filter(item => item.type === 'cclones' && !isNil(item.strong_classifiers_family_id))
    },

    /**
     * Get only shared Audience
     *
     * @param {Object} state Vuex state for audiences module
     * @returns {Array} List of shared audiences
     */
    getSharedAudiences: state => () => {
        return state.list.filter(item => item.status === 'active' && !isNil(item.sharedAudience))
    },

    changeRowData: state => state.changeRowData,
}

export default { ...commonGetters, ...getters }
